import api from './axios';

export const getTicketWorkNotesList = async (ticketId) => {
  const response = await api.get(`/work-notes-list/ticket/${ticketId}`);
  return response.data;
};

export const addToWorkNotesList = async (ticketId, userId) => {
  const response = await api.post(`/work-notes-list/ticket/${ticketId}`, { user_id: userId });
  return response.data;
};

export const removeFromWorkNotesList = async (ticketId, userId = null) => {
  const url = userId
    ? `/work-notes-list/ticket/${ticketId}/user/${userId}`
    : `/work-notes-list/ticket/${ticketId}`;
  const response = await api.delete(url);
  return response.data;
};
